export const storagePaths = {
  avatarUrls: (userId: string) => `avatarUrls/${userId}`,
};
